module.exports = __webpack_public_path__ + "img/Umidade.3914096f.svg";